import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";
import { createApi } from "~/api/createApi.server";
import type { GetTermPayload, GetSessionsRegionPayload } from "~/payloads";

export async function loader({ request }: LoaderFunctionArgs) {
  const api = await createApi(request);

  const sessionRegion = await api.getJson<GetSessionsRegionPayload>({
    endpoint: "/_/aa00/sessions/region",
  });

  const data = await api.getJson<GetTermPayload>({
    endpoint: "/_/aa00/legals/venus_term",
    params: {
      ...(sessionRegion.result && {
        region: sessionRegion.result.langCode,
      }),
    },
  });

  return json({
    data,
  });
}

export default function Legals() {
  const { data } = useLoaderData<typeof loader>();

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: data.result[0].description,
      }}
    />
  );
}
